import { render } from "./EditPasswordDialog.vue?vue&type=template&id=6f2701dc"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=js"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/transport/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__